
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitoganpatipunecab() {



    const cardData =
    {
        keyword: ' Mumbai to Ganpatipule Cab  ',
        heading: 'Deva Cabs: Mumbai to Ganpatipule Cab  ',
        headingDescription: 'Deva Cabs provides comfortable and dependable cab services from Mumbai to Ganpatipule, ideal for beach vacations, family trips, and weekend getaways. Covering a distance of approximately 375 km, our well-maintained vehicles—Sedans, SUVs, and Innova Crysta—ensure a smooth and relaxing journey through scenic Konkan routes. Whether you are traveling solo, with family, or in a larger group, enjoy the convenience of experienced drivers, fixed-fare packages, and flexible door-to-door pickups. With 24/7 availability, transparent pricing, and customer-focused support, Deva Cabs makes your Mumbai to Ganpatipule cab journey stress-free, safe, and memorable.',

        top: 'Top Places to Visit in Ganpatipule with Deva Cabs',

"topPlaces": [
  {
    "title": "Swayambhu Ganpati Temple",
    "location": "Ganpatipule, Ratnagiri District, Maharashtra",
    "description": "This ancient 400‑year‑old temple houses a self‑manifested Ganesha idol carved from white sand (pule) that unexpectedly appeared centuries ago. The deity faces west—unlike most—believed to guard the Konkan coast. The spiritual ambiance, combined with breathtaking sea views, makes it a pilgrimage highlight."
  },
  {
    "title": "Ganpatipule Beach",
    "location": "Ganpatipule, Ratnagiri District, Maharashtra",
    "description": "A pristine, rocky beach with silvery‑white sand and a natural lagoon framed by coconut palms. Clean waters, calm tides, and vibrant sunsets attract families and couples. Water‑sports options include jet‑ski, banana rides, speedboats, and even camel/horse rides along the shore." 
  },
  {
    "title": "Prachin Konkan Museum",
    "location": "Ganpatipule, Ratnagiri District, Maharashtra",
    "description": "An open‑air heritage museum showcasing life‑size sculptures and exhibits depicting traditional Konkan village life from 300–500 years ago. A cultural immersion that's both educational and deeply evocative of the region’s history."
  },
  {
    "title": "Aare Ware Beach",
    "location": "Near Ganpatipule, Ratnagiri District, Maharashtra",
    "description": "Also called Aare‑Ware or Aarey‑Ware, this tranquil twin‑crescent beach lies about 10 km north. Known for its pristine sands, gentle waves, and Suru trees, it's an undeveloped, garbage‑free haven ideal for solitude, quiet walks, and romantic sunsets."
  },
  {
    "title": "Jaigad Fort & Lighthouse",
    "location": "Jaigad, Ratnagiri District, Maharashtra",
    "description": "Perched on a cliff at the confluence of the Shastri River and the Arabian Sea, this 16th‑century fort (built by the Bijapur sultans, later held by Marathas) features massive stone walls, bastions, a small Ganpati shrine, water cisterns, and an adjacent British‑built lighthouse—stunning for history buffs and coastal photos."
  },
  {
    "title": "Malgund & Kavi Keshavsut Memorial",
    "location": "Malgund, near Ganpatipule, Ratnagiri District, Maharashtra",
    "description": "The birthplace of Marathi poet Kavi Keshavsut, this charming village features a small memorial museum preserving his legacy, along with rustic Konkan surroundings—ideal for literature lovers and cultural wanderers."
  },
  {
    "title": "Water‑sports & Beach Activities",
    "location": "Ganpatipule Beach, Ganpatipule, Maharashtra",
    "description": "Organized during peak season by MTDC and local vendors, options include jet‑skiing, banana/boogie rides, speed‑boat tours, and parasailing—perfect for thrill-seekers looking for adventure along Goa’s quieter northern Konkan coast."
  },
  {
    "title": "Advika and Malgund Beaches",
    "location": "Around Ganpatipule, Ratnagiri District, Maharashtra",
    "description": "Less crowded than the main beach, these hidden sandy pockets offer serene ambiance, coastal exploration, and scenic solitude—great for photographers, meditation, or simply soaking up nature’s beauty in peace."
  },
  {
    "title": "Local Shopping & Malvani Cuisine",
    "location": "Ganpatipule Market Area, Maharashtra",
    "description": "Browse stalls selling fresh kokum, dried mango products, cashews, local spices, and handcrafted souvenirs. Don’t miss trying Malvani specialties—fresh coconut rice, sol kadi, fish curry (seasonal), and sweet modaks."
  },
  {
    "title": "Nearby Velneshwar & Pawas",
    "location": "Within 30 km of Ganpatipule, Ratnagiri District, Maharashtra",
    "description": "Velneshwar—about 38 km south—is a quiet village with a rock‑free beach and ancient Shiva temple, bustling during Shivratri. Pawas hosts the serene Swami Swaroopanand Ashram—perfect for a spiritual side‑trip."
  }
],



  "services": [
    {
      "name": "Mumbai to Ganpatipule Cab",
      "description": "Travel from Mumbai to the serene town of Ganpatipule with Deva Cabs’ reliable cab services. Ideal for spiritual trips, beach holidays, or nature getaways, our cabs offer a smooth and comfortable ride through the scenic Konkan region. Choose from AC sedans, SUVs, or premium vehicles with trained, courteous chauffeurs who ensure a stress-free experience. Whether you’re heading for a temple visit or a weekend retreat, we provide doorstep pickup, flexible packages, and competitive fares."
    },
    {
      "name": "One-way taxi Mumbai to Ganpatipule",
      "description": "Book a one-way taxi from Mumbai to Ganpatipule with ease through Deva Cabs. Perfect for solo travelers, couples, or families planning a one-directional trip to the Konkan coast, our service ensures clean, well-maintained vehicles, experienced drivers, and transparent rates with no hidden fees. Hassle-free booking and on-time service guaranteed."
    },
    {
      "name": "Round trip Ganpatipule cab from Mumbai",
      "description": "Planning to return to Mumbai after visiting Ganpatipule? Opt for our round trip cab service and enjoy a worry-free ride both ways. Our drivers are familiar with the route and offer safe, smooth travel through scenic landscapes. Ideal for families and small groups, our round trip packages come with customizable stops, waiting time options, and budget-friendly pricing."
    },
    {
      "name": "Pilgrimage cab Mumbai to Ganpatipule",
      "description": "Ganpatipule is one of Maharashtra’s most revered temple towns, and Deva Cabs makes your pilgrimage smooth and respectful. Our pilgrimage cab service includes verified drivers, comfortable seating, and dedicated options for elders or group tours. Travel to the Swayambhu Ganpati Temple and nearby religious spots with complete peace of mind."
    },
    {
      "name": "Chauffeur-driven cab to Ganpatipule from Mumbai",
      "description": "Enjoy a premium chauffeur-driven cab experience from Mumbai to Ganpatipule. Our drivers are punctual, polite, and knowledgeable about the Konkan terrain. From luggage handling to route assistance, they ensure a high-standard service, so you can simply relax and enjoy the scenic coastal journey."
    },
    {
      "name": "SUV cab hire Mumbai to Ganpatipule",
      "description": "Travel in comfort and style with our spacious SUV cabs for the Mumbai to Ganpatipule route. Ideal for families, small groups, or those carrying extra luggage, our SUVs offer a smooth ride on long coastal stretches. AC, music system, and ample legroom included."
    },
    {
      "name": "Online booking Mumbai to Ganpatipule taxi",
      "description": "Book your Mumbai to Ganpatipule taxi online with Deva Cabs in just a few clicks. Our website and support team ensure instant confirmations, easy modifications, and secure payment options. No paperwork, no waiting—just smooth and simple cab booking from anywhere, anytime."
    },
    {
      "name": "Affordable Ganpatipule cab Mumbai",
      "description": "Looking for a budget-friendly cab to Ganpatipule from Mumbai? We offer affordable yet reliable transport without compromising on quality. All fares are upfront and inclusive of fuel, tolls, and driver charges. Whether it’s a one-way ride or a return trip, our pricing suits all travel needs."
    }
  ],
  "tableData": [
    ["Mumbai to Ganpatipule Cab", "-One-way taxi Mumbai to Ganpatipule"],
    ["Round trip Ganpatipule cab from Mumbai", "-Pilgrimage cab Mumbai to Ganpatipule"],
    ["Chauffeur-driven cab to Ganpatipule from Mumbai", "-SUV cab hire Mumbai to Ganpatipule"],
    ["Online booking Mumbai to Ganpatipule taxi", "-Affordable Ganpatipule cab Mumbai"]
  ],

whychoose: [
  {
    "WhyChooseheading": "Comfortable Mumbai to Ganpatipule Cab Service",
    "WhyChoosedescription": "Escape the city and travel to the serene coastal town of Ganpatipule with our trusted cab service. Ideal for pilgrims, beach lovers, and families, our service offers a smooth and peaceful journey across the scenic 340 km route from Mumbai to this popular Konkan destination."
  },
  {
    "WhyChooseheading": "Spacious and Well-Equipped Vehicles for Coastal Travel",
    "WhyChoosedescription": "Our fleet includes sedans, SUVs, and tempo travellers perfect for solo travelers, couples, or large groups. Enjoy plush seating, ample legroom, air conditioning, and enough luggage space to comfortably accommodate long-distance travel to the beaches and temples of Ganpatipule."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Route Expertise",
    "WhyChoosedescription": "Our drivers are experienced with the Mumbai–Ganpatipule highway route and familiar with key stops and shortcuts along the way. Whether you want a direct trip or to explore scenic spots en route, our drivers ensure a safe, pleasant, and well-informed journey."
  },
  {
    "WhyChooseheading": "Flexible Tour Packages for One-Way, Round Trip, or Multi-Day Stay",
    "WhyChoosedescription": "We offer fully customizable travel plans—whether it’s a simple one-way drop, a weekend retreat with return, or a multi-day coastal tour. Add stops like Ratnagiri, Velneshwar, or Jaigad Fort to your itinerary for a complete Konkan experience."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Enjoy transparent, all-inclusive fares with no hidden costs. Our Mumbai to Ganpatipule cab pricing includes tolls, fuel, and driver charges—giving you complete control over your travel budget with no unpleasant surprises."
  },
  {
    "WhyChooseheading": "24/7 Service Availability for Your Convenience",
    "WhyChoosedescription": "Planning an early morning start to beat the traffic? Or a late-night departure to maximize your weekend? Our cabs operate round-the-clock, so you can schedule your journey at a time that works best for you."
  },
  {
    "WhyChooseheading": "Easy Booking and Instant Confirmation",
    "WhyChoosedescription": "Book your Mumbai to Ganpatipule cab online or through our customer support in just a few steps. Receive instant confirmation, complete trip details, and driver information to keep your travel stress-free and well-organized."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles with GPS Tracking",
    "WhyChoosedescription": "All cabs are regularly maintained, cleaned, and equipped with GPS tracking, first-aid kits, and seat belts. We follow stringent safety standards to make sure your journey to Ganpatipule is secure, comfortable, and worry-free."
  }
]











    }




const faqData = [
  {
    question: "Can I book a cab from Mumbai to Ganpatipule with Deva Cabs?",
    answer: "Yes, Deva Cabs provides reliable and comfortable cab services from Mumbai to Ganpatipule for family trips, pilgrimages, and leisure travel."
  },
  {
    question: "How long does the journey from Mumbai to Ganpatipule take by cab?",
    answer: "The trip usually takes around 8 to 10 hours depending on traffic, weather, and road conditions."
  },
  {
    question: "What types of vehicles are available for Mumbai to Ganpatipule?",
    answer: "We offer a wide range of vehicles including sedans, SUVs, Innova Crysta, Ertiga, and tempo travellers to suit your group size and preferences."
  },
  {
    question: "Can I book a one-way cab to Ganpatipule from Mumbai?",
    answer: "Yes, Deva Cabs provides both one-way and round-trip cab services from Mumbai to Ganpatipule."
  },
  {
    question: "Are tolls and driver charges included in the fare?",
    answer: "Toll charges, parking, and driver allowance are usually extra and will be clearly mentioned at the time of booking."
  },
  {
    question: "Is the service available 24/7 for Mumbai to Ganpatipule?",
    answer: "Yes, you can book a cab to Ganpatipule at any time. Our services are available round-the-clock."
  },
  {
    question: "Is it safe to travel from Mumbai to Ganpatipule with Deva Cabs?",
    answer: "Absolutely. Our drivers are experienced and background-verified, and our vehicles are maintained to ensure safe and smooth travel."
  },
  {
    question: "Can I customize the route or request stopovers on the way?",
    answer: "Yes, you can customize your journey with stopovers for sightseeing, food, or rest upon request during booking."
  },
  {
    question: "Is this service suitable for pilgrims visiting Ganpatipule Temple?",
    answer: "Yes, many of our customers travel to Ganpatipule for religious purposes, and we ensure a comfortable and respectful journey."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Ganpatipule travel?",
    answer: "Deva Cabs offers well-maintained vehicles, professional drivers, transparent pricing, and 24/7 support for a stress-free travel experience."
  }
];

const testimonialData = [
  {
    id: 75,
    name: 'Mr. Kiran Deshmukh',
    role: 'Pilgrim',
    review: 'Our visit to Ganpatipule with Deva Cabs was smooth and peaceful. The driver was very cooperative and respectful throughout the trip.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 76,
    name: 'Ms. Sneha Apte',
    role: 'Tourist',
    review: 'We had a wonderful road trip to Ganpatipule with Deva Cabs. Clean vehicle, helpful driver, and great service overall.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];

















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ganpatipule Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-ganpatipule-cab.jpg", // Replace with actual image URL
  "description": "Book Mumbai to Ganpatipule cab with Deva Cabs. Affordable, chauffeur-driven SUV and taxi service for one-way and round trips. Easy online booking for pilgrimage and family trips.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "280",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-ganpatipule-cab" // Replace with actual URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Ganpatipule Cab | Book Ganpatipule Taxi | Deva Cabs</title>
  <meta
    name="description"
    content="Affordable Mumbai to Ganpatipule cab service with Deva Cabs. Chauffeur-driven SUVs and taxis for pilgrimage, family trips, one-way and round trips. Book online easily."
  />
  <meta
    name="keywords"
    content="Mumbai to Ganpatipule Cab, One-way taxi Mumbai to Ganpatipule, Round trip Ganpatipule cab from Mumbai, Pilgrimage cab Mumbai to Ganpatipule, Chauffeur-driven cab to Ganpatipule from Mumbai, SUV cab hire Mumbai to Ganpatipule, Online booking Mumbai to Ganpatipule taxi, Affordable Ganpatipule cab Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/47.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitoganpatipunecab;